<template>
    <nav class="bg-primary-800 z-20">
        <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
            <div class="relative flex items-center justify-between h-16">
                <div class="flex items-center px-2 lg:px-0">
                    <div class="flex-shrink-0 text-white text-2xl">
                        <a class="block lg:hidden h-8 w-auto" href="/">UD</a>
                        <a class="hidden lg:block h-8 w-auto" href="/">used-design</a>
                    </div>
                    <div v-if="!hideNav" class="hidden lg:block lg:ml-6">
                        <div class="flex space-x-3">
                            <!-- OFFERS DROP DOWN -->
                            <div class="relative inline-block text-left nav-dropdown">
                                <div @click="toggleDdOffers">
                                    <button @blur="hideDdOffers" type="button" class="inline-flex justify-center w-full rounded-md px-4 py-2 bg-primary-800 text-sm font-medium text-white hover:bg-primary-900" id="menu-button" aria-expanded="true" aria-haspopup="true">
                                        {{ translations.offers }}
                                        <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                <div
                                    class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="menu-button"
                                    tabindex="-1"
                                    v-show="ddOfferVisible"
                                >
                                    <div class="py-1" role="none">
                                        <a :href="routes.offerSearchAll" class="nav-dropdown-item" role="menuitem" tabindex="-1" id="menu-item-0">{{ translations.all_offers }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a v-for="(cat, index) in categories" :key="index" :href="cat.url" class="nav-dropdown-item" role="menuitem" tabindex="-1">{{ cat.label }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a :href="routes.pagesCategories" class="text-gray-700 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-16">{{ translations.all_categories }}</a>
                                    </div>
                                </div>
                            </div>

                            <a :href="routes.offerRequestList" class="text-white hover:bg-primary-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium">{{ translations.offer_requests }}</a>

                            <!-- SERVICES DROP DOWN -->
                            <div class="relative inline-block text-left nav-dropdown">
                                <div @click="toggleDdServices">
                                    <button @blur="hideDdServices" type="button" class="inline-flex justify-center w-full rounded-md px-4 py-2 bg-primary-800 text-sm font-medium text-white hover:bg-primary-900" id="menu-button" aria-expanded="true" aria-haspopup="true">
                                        {{ translations.services }}
                                        <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                <div
                                        class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
                                        role="menu"
                                        aria-orientation="vertical"
                                        aria-labelledby="menu-button"
                                        tabindex="-1"
                                        v-show="ddServicesVisible"
                                >
                                    <div class="py-1" role="none">
                                        <a :href="routes.transportPricelist" class="nav-dropdown-item" role="menuitem" tabindex="-1">
                                            <div class="group flex flex-row items-center space-x-2">
                                                <i class="fas fa-truck"></i>
                                                <div>{{ translations.transport }}</div>
                                            </div>
                                        </a>
                                        <a href="https://blog.used-design.com/mediadaten-und-werbung?utm_source=www.used-design.com&utm_campaign=service-nav&utm_medium=link&utm_content=advertising" class="nav-dropdown-item" role="menuitem" tabindex="-1" target="_blank">
                                            <div class="group flex flex-row items-center space-x-2">
                                                <i class="fas fa-bullseye"></i>
                                                <div>{{ translations.advertising }}</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <a :href="routes.pagesSellersInfo" class="text-white hover:bg-primary-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium">{{ translations.sellers_info }}</a>
                            <a href="https://blog.used-design.com" class="text-white hover:bg-primary-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium" target="_blank">Blog</a>
                        </div>
                    </div>
                </div>
                <div v-if="!hideNav" class="flex-1 flex justify-center px-2 lg:ml-6 lg:justify-end">
                    <form :action="routes.offerSearchSearch" method="get">
                        <div class="max-w-lg w-full lg:max-w-xs">
                            <label for="search" class="sr-only">Search</label>
                            <div class="relative">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                                    </svg>
                                </div>
                                <input id="search" name="s" class="block w-full pl-10 pr-3 py-2 border border-transparent rounded-md leading-5 bg-primary-300 text-white placeholder-gray-50 focus:outline-none focus:bg-white focus:border-white focus:ring-white focus:text-gray-900 sm:text-sm" :placeholder="translations.search" type="search">
                                <input type="hidden" name="sort" value="relevance">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="flex lg:hidden">
                    <button @click="toggleMobileNavDd" type="button" class="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-primary-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
                        <span class="sr-only">Open main menu</span>
                        <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>
                <div class="hidden lg:block lg:ml-4">
                    <div class="flex items-center">
                        <template v-if="!authStatus">
                            <a :href="routes.login" class="text-white hover:bg-primary-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium">{{ translations.login }}</a>
                        </template>
                        <template v-else>
                            <!-- Profile dropdown -->
                            <div class="ml-4 relative flex-shrink-0 nav-dropdown">
                                <div @click="toggleDdUserMenu">
                                    <button @blur="hideDdUserMenu" type="button" class="flex text-sm text-white focus:outline-none" id="user-menu-button" aria-expanded="false" aria-haspopup="true">
                                        {{ user.firstName }} {{ user.lastName }}
                                        <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                <div
                                    class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="user-menu-button"
                                    tabindex="-1"
                                    v-show="ddUserMenuVisible"
                                >
                                    <div class="py-1" role="none">
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userDashboard">{{ translations.dashboard }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userOfferCreate">{{ translations.create_offer }}</a>
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userOfferList">{{ translations.my_offers }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userFavorites">{{ translations.favorites }}</a>
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.savedSearchIndex">{{ translations.saved_searches }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userOfferRequestCreate">{{ translations.create_offer_request }}</a>
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userOfferRequestList">{{ translations.my_offer_requests }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userConversationList">{{ translations.section_conversation }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userTransportCreate">{{ translations.book_transport }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userSubscriptionShow">{{ translations.my_premium_membership }}</a>
                                    </div>
                                    <div class="py-1" role="none">
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userMyDataShow">{{ translations.my_data }}</a>
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userSettingEdit">{{ translations.settings }}</a>
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userProfilePageEdit">{{ translations.profile_page }}</a>
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userInvoice">{{ translations.invoices }}</a>
                                        <a class="nav-dropdown-item" role="menuitem" tabindex="-1" :href="routes.userLinksShow">{{ translations.link_website }}</a>
                                    </div>
                                    <a href="#" @click.prevent="logout" class="nav-dropdown-item" role="menuitem" tabindex="-1">{{ translations.logout }}</a>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile menu -->
        <div class="lg:hidden" id="mobile-menu" v-if="mobileNavDdVisible">
            <div class="px-2 pt-2 pb-3 space-y-1 nav-mobile-dropdown">
                <a :href="routes.offerSearchAll" class="nav-mobile-dropdown-item" role="menuitem" tabindex="-1">{{ translations.all_offers }}</a>
                <a v-for="(cat, index) in categories" :key="'mob-' + index" :href="cat.url" class="nav-mobile-dropdown-item indent" role="menuitem" tabindex="-1">{{ cat.label }}</a>
                <a :href="routes.pagesCategories" class="nav-mobile-dropdown-item" role="menuitem" tabindex="-1">{{ translations.all_categories }}</a>
                <a :href="routes.offerRequestList" class="nav-mobile-dropdown-item">{{ translations.offer_requests }}</a>

                <a :href="routes.transportPricelist" class="nav-mobile-dropdown-item" role="menuitem" tabindex="-1">{{ translations.transport }}</a>
                <a href="https://blog.used-design.com/mediadaten-und-werbung?utm_source=www.used-design.com&utm_campaign=service-nav&utm_medium=link&utm_content=advertising" class="nav-mobile-dropdown-item" role="menuitem" tabindex="-1" target="_blank">{{ translations.advertising }}</a>
                <a :href="routes.pagesSellersInfo" class="nav-mobile-dropdown-item">{{ translations.sellers_info }}</a>
                <a href="https://blog.used-design.com" class="nav-mobile-dropdown-item" target="_blank">Blog</a>
                <hr>

                <template v-if="!authStatus">
                    <a :href="routes.login" class="nav-mobile-dropdown-item" role="menuitem" tabindex="-1">{{ translations.login }}</a>
                </template>
                <template v-else>
                    <a class="nav-mobile-dropdown-item" :href="routes.userDashboard">{{ translations.dashboard }}</a>
                    <div class="pt-4">
                        <a class="nav-mobile-dropdown-item" :href="routes.userOfferCreate">{{ translations.create_offer }}</a>
                        <a class="nav-mobile-dropdown-item" :href="routes.userOfferList">{{ translations.my_offers }}</a>
                    </div>
                    <div class="pt-4">
                        <a class="nav-mobile-dropdown-item" :href="routes.userFavorites">{{ translations.favorites }}</a>
                        <a class="nav-mobile-dropdown-item" :href="routes.savedSearchIndex">{{ translations.saved_searches }}</a>
                    </div>
                    <div class="pt-4">
                        <a class="nav-mobile-dropdown-item" :href="routes.userOfferRequestCreate">{{ translations.create_offer_request }}</a>
                        <a class="nav-mobile-dropdown-item" :href="routes.userOfferRequestList">{{ translations.my_offer_requests }}</a>
                    </div>
                    <div class="pt-4">
                        <a class="nav-mobile-dropdown-item" :href="routes.userConversationListActive">{{ translations.conversation_active }}</a>
                        <a class="nav-mobile-dropdown-item" :href="routes.userConversationListArchive">{{ translations.conversation_archive }}</a>
                    </div>
                    <div class="pt-4">
                        <a class="nav-mobile-dropdown-item" :href="routes.userTransportCreate">{{ translations.book_transport }}</a>
                    </div>
                    <div class="pt-4">
                        <a class="nav-mobile-dropdown-item" :href="routes.userSubscriptionShow">{{ translations.my_premium_membership }}</a>
                    </div>
                    <div class="pt-4">
                        <a class="nav-mobile-dropdown-item" :href="routes.userMyDataShow">{{ translations.my_data }}</a>
                        <a class="nav-mobile-dropdown-item" :href="routes.userSettingEdit">{{ translations.settings }}</a>
                        <a class="nav-mobile-dropdown-item" :href="routes.userProfilePageEdit">{{ translations.profile_page }}</a>
                        <a class="nav-mobile-dropdown-item" :href="routes.userInvoice">{{ translations.invoices }}</a>
                        <a class="nav-mobile-dropdown-item" :href="routes.userLinksShow">{{ translations.link_website }}</a>
                    </div>
                    <div class="pt-4">
                        <a class="nav-mobile-dropdown-item" href="#" @click.prevent="logout">{{ translations.logout }}</a>
                    </div>
                </template>
            </div>
        </div>
        <form ref="logoutForm" :action="routes.logout" method="POST" style="display: none;">
            <input type="hidden" name="_token" :value="csrfToken">
        </form>
    </nav>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    translations: {
        type: Object,
        required: true
    },
    routes: {
        type: Object,
        required: true
    },
    user: {
        type: Object,
        default: () => null
    },
    authStatus: {
        type: Boolean,
        default: false
    },
    hideNav: {
        type: Boolean,
        default: false
    },
    csrfToken: {
        type: String,
        required: true
    }
});

const ddOfferVisible = ref(false);
const ddServicesVisible = ref(false);
const ddUserMenuVisible = ref(false);
const mobileNavDdVisible = ref(false);

const logoutForm = ref(null);

const categories = computed(() => [
    { label: props.translations.bathroom, url: props.routes.categoryBathroom },
    { label: props.translations.beds, url: props.routes.categoryBeds },
    { label: props.translations.cloakroom, url: props.routes.categoryCloakroom },
    { label: props.translations.garden_furniture, url: props.routes.categoryGardenFurniture },
    { label: props.translations.kids_furniture, url: props.routes.categoryKidsFurniture },
    { label: props.translations.occasional_furniture, url: props.routes.categoryOccasionalFurniture },
    { label: props.translations.art, url: props.routes.categoryArt },
    { label: props.translations.kitchen, url: props.routes.categoryKitchen },
    { label: props.translations.lamps, url: props.routes.categoryLamps },
    { label: props.translations.shelfs_cupboards, url: props.routes.categoryShelfsCupboards },
    { label: props.translations.sideboards, url: props.routes.categorySideboards },
    { label: props.translations.sofas_armchairs, url: props.routes.categorySofasArmchairs },
    { label: props.translations.miscellaneous, url: props.routes.categoryMiscellaneous },
    { label: props.translations.chairs, url: props.routes.categoryChairs },
    { label: props.translations.carpets_textiles, url: props.routes.categoryCarpetsTextiles },
    { label: props.translations.tables, url: props.routes.categoryTables },
]);

const toggleDdOffers = () => {
    ddOfferVisible.value = !ddOfferVisible.value;
};

const hideDdOffers = () => {
    setTimeout(() => {
        ddOfferVisible.value = false;
    }, 500);
};

const toggleDdServices = () => {
    ddServicesVisible.value = !ddServicesVisible.value;
};

const hideDdServices = () => {
    setTimeout(() => {
        ddServicesVisible.value = false;
    }, 500);
};

const toggleDdUserMenu = () => {
    ddUserMenuVisible.value = !ddUserMenuVisible.value;
};

const hideDdUserMenu = () => {
    setTimeout(() => {
        ddUserMenuVisible.value = false;
    }, 500);
};

const toggleMobileNavDd = () => {
    mobileNavDdVisible.value = !mobileNavDdVisible.value;
};

const logout = () => {
    logoutForm.value.submit();
};
</script>
